<ng-container>
    <a [attr.href]="item.url" (click)="itemClick(item, $event)" *ngIf=" item.visible !== false" (mouseenter)="onMouseEnter()"
       (keydown.enter)="itemClick(item, $event)" [ngClass]="item.class" pRipple
       [attr.target]="item.target" [attr.tabindex]="0" [pTooltip]="item.label">
        <ng-container *ngIf="isIconExist(item.icon)">
            <i [ngClass]="item.icon"
               *ngIf="containIcon(item.icon); else elseImgBlock"
               class="layout-menuitem-icon"></i>
            <ng-template #elseImgBlock>
                <img [ngClass]="{'icon-margin': !app.sidebarActive}" src="/XpressApp/assets/layout/images/menu/{{getIconName(item.icon)}}" style="width: 24px;"/>
            </ng-template>
        </ng-container>

        <span class="layout-menuitem-text">{{item.label}}</span>
        <i class="pi pi-fw pi-chevron-down layout-submenu-toggler" [ngStyle]="{'margin-right': getPaddingForSubItem(item)}" *ngIf="item.items"></i>
    </a>

    <div class="layout-menu-tooltip">
        <div class="layout-menu-tooltip-arrow"></div>
        <div class="layout-menu-tooltip-text" [ngClass]="{'hidden': app.sidebarActive}">{{item.label}}</div>
    </div>
    <ul *ngIf="active && item.visible !== false" [@children]="((app.isSlim()||app.isHorizontal()) && !app.isMobile() && root) ? (active ? 'visible' : 'hidden') :
				(active ? 'visibleAnimated' : 'hiddenAnimated')" [ngClass]="{'hidden': !app.sidebarActive}" role="menu">
        <ol>
            <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
                <li app-menuitem [item]="child" [index]="i" [parentKey]="key" [attr.data-testid]="navigationMenuTestId(child)"></li>
            </ng-template>
        </ol>
    </ul>
</ng-container>
